@if (Contract) {
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="row">
          <h3>Contract Info</h3>
          <hr />
          <div class="col-12 col-md-4">
            <div class="row align-items-center justify-content-center">
              <div class="col-6">
                <label>Contract Name: </label>
              </div>
              <div class="col-6">
                <p class="m-0">{{ Contract.contractName }}</p>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-6">
                <label>Cancellation Method: </label>
              </div>
              <div class="col-6">
                <p class="m-0">{{ Contract.cancellationDeliveryMethod }}</p>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-6">
                <label>Total Value: </label>
              </div>
              <div class="col-6">
                <p class="m-0">{{ Contract.totalContractValue | currency }}</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="row align-items-center">
              <div class="col-6">
                <label>Start Date: </label>
              </div>
              <div class="col-6">
                <p class="m-0">{{ Contract.startDate | date }}</p>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-6">
                <label>Reminder Date: </label>
              </div>
              <div class="col-6">
                <p class="m-0">{{ Contract.renewalDate | date }}</p>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-6">
                <label>Auto-Renews?: </label>
              </div>
              <div class="col-6">
                <p class="m-0">{{ Contract.autoRenewing ? 'Yes' : 'No' }}</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="row align-items-center">
              <div class="col-6">
                <label>Expiration Date: </label>
              </div>
              <div class="col-6">
                <p class="m-0">{{ Contract.expirationDate | date }}</p>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-6">
                <label>Billing Frequency: </label>
              </div>
              <div class="col-6">
                <p class="m-0">
                  {{
                    Contract.FrequencyPeriod &&
                    Contract.FrequencyPeriod.periodName
                      ? Contract.FrequencyPeriod.periodName
                      : ''
                  }}
                </p>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-6">
                <label>Auto-Renewal Term (months): </label>
              </div>
              <div class="col-6">
                <p class="m-0">{{ Contract.renewalTerm }}</p>
              </div>
            </div>
          </div>
        </div>
        @if (Site && SiteContact) {
          <div class="row py-2">
            <div class="col">
              <h3>Site Contact Info</h3>
              <hr />
              <div class="row">
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label for="contractSiteName">Contract Site: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ Site.legalName }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label for="contractSiteName">First Name: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ SiteContact.firstName }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label for="contractSiteName">Last Name: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ SiteContact.lastName }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label for="contractSiteName">Job Title: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ SiteContact.jobTitle }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label for="contractSiteName">Primary Phone: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ SiteContact.phone1 }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label for="contractSiteName">Ext: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ SiteContact.ext }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <div class="col-6">
                    <label for="contractSiteName">Secondary Phone: </label>
                  </div>
                  <div class="col-6">
                    <p class="m-0">{{ SiteContact.phone2 }}</p>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label for="contractSiteName">Ext2: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ SiteContact.ext2 }}</p>
                    </div>
                  </div>
                </div>
              </div>
              @if (SiteContact && SiteContact.StreetAddress) {
                <div class="row">
                  <div class="row">
                    <div class="col-4">
                      <div class="row align-items-center">
                        <div class="col-6">
                          <label for="contractSiteName">Address: </label>
                        </div>
                        <div class="col-6">
                          <p class="m-0">
                            {{ SiteContact.StreetAddress.address1 }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="row align-items-center">
                        <div class="col-6">
                          <label for="contractSiteName">Address 2: </label>
                        </div>
                        <div class="col-6">
                          <p class="m-0">
                            {{ SiteContact.StreetAddress.address2 }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      <div class="row align-items-center">
                        <div class="col-6">
                          <label for="contractSiteName">City: </label>
                        </div>
                        <div class="col-6">
                          <p class="m-0">
                            {{ SiteContact.StreetAddress.city }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="row align-items-center">
                        <div class="col-6">
                          <label for="contractSiteName"
                            >{{
                              localizationInfo && localizationInfo.postalCode
                                ? localizationInfo.postalCode.label
                                : 'State'
                            }}:
                          </label>
                        </div>
                        <div class="col-6">
                          <p class="m-0">
                            {{ SiteContact.StreetAddress.state }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="row align-items-center">
                        <div class="col-6">
                          <label for="contractSiteName"
                            >{{
                              localizationInfo && localizationInfo.postalCode
                                ? localizationInfo.postalCode.label
                                : 'Zip'
                            }}:
                          </label>
                        </div>
                        <div class="col-6">
                          <p class="m-0">{{ SiteContact.StreetAddress.zip }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @if (Vendor && VendorContact) {
          <div class="row py-2">
            <div class="col">
              <h3>Vendor Contact Info</h3>
              <hr />
              <div class="row">
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label for="contractVendorName">Contract Vendor: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ Vendor.legalName }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label for="contractVendorName">First Name: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ VendorContact.firstName }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label for="contractVendorName">Last Name: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ VendorContact.lastName }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label for="contractVendorName">Job Title: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ VendorContact.jobTitle }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label for="contractVendorName">Primary Phone: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ VendorContact.phone1 }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label for="contractVendorName">Ext: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ VendorContact.ext }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <div class="col-6">
                    <label for="contractVendorName">Secondary Phone: </label>
                  </div>
                  <div class="col-6">
                    <p class="m-0">{{ VendorContact.phone2 }}</p>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label for="contractVendorName">Ext2: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ VendorContact.ext2 }}</p>
                    </div>
                  </div>
                </div>
              </div>
              @if (VendorContact && VendorContact.StreetAddress) {
                <div class="row">
                  <div class="row">
                    <div class="col-4">
                      <div class="row align-items-center">
                        <div class="col-6">
                          <label for="contractVendorName">Address: </label>
                        </div>
                        <div class="col-6">
                          <p class="m-0">
                            {{ VendorContact.StreetAddress.address1 }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="row align-items-center">
                        <div class="col-6">
                          <label for="contractVendorName">Address 2: </label>
                        </div>
                        <div class="col-6">
                          <p class="m-0">
                            {{ VendorContact.StreetAddress.address2 }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      <div class="row align-items-center">
                        <div class="col-6">
                          <label for="contractVendorName">City: </label>
                        </div>
                        <div class="col-6">
                          <p class="m-0">
                            {{ VendorContact.StreetAddress.city }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="row align-items-center">
                        <div class="col-6">
                          <label for="contractVendorName"
                            >{{
                              localizationInfo && localizationInfo.territory
                                ? localizationInfo.territory.label
                                : 'State'
                            }}:
                          </label>
                        </div>
                        <div class="col-6">
                          <p class="m-0">
                            {{ VendorContact.StreetAddress.state }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="row align-items-center">
                        <div class="col-6">
                          <label for="contractVendorName"
                            >{{
                              localizationInfo && localizationInfo.postalCode
                                ? localizationInfo.postalCode.label
                                : 'Zip'
                            }}:
                          </label>
                        </div>
                        <div class="col-6">
                          <p class="m-0">
                            {{ VendorContact.StreetAddress.zip }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      <div class="row align-items-center">
                        <div class="col-6">
                          <label for="contractVendorName"
                            >Vendor Rating:
                          </label>
                        </div>
                        @if (overallVendorRating) {
                          <div class="col-6">
                            <app-star-rating
                              [rating]="overallVendorRating"
                              [size]="3"
                            ></app-star-rating>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @if (Files && Files.length > 0) {
          <div class="row py-2">
            <h3>Contract Files</h3>
            <hr />
            <div class="col">
              @for (file of Files; track file) {
                @if (file && file.id) {
                  <div class="row">
                    <div class="col">
                      <label>{{ file.filename }}</label>
                      <a
                        (click)="downloadContractDocument(file.id)"
                        class="text-primary ms-2"
                        role="button"
                      >
                        <i class="bi bi-download fs-28"></i>
                      </a>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
